import React from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';
import styles from './AdvtFullSize.module.css';

import { BgVideo } from '../BgVideo/BgVideo';
import { WordAnimator } from '../WordAnimator/WordAnimator';

export const AdvtFullSize = React.memo(() => {
  const { sizeQR, qrCode1, qrCode2, title } = useGetParams();

  const advtlines = title?.split(/\\n/)?.map((l) => l.trim());
  const initDelay = 4;

  return (
    <div className={styles.wrapper}>
      {advtlines && (
        <motion.div
          animate={{ opacity: 0 }}
          transition={{ duration: 0.5, delay: 10 }}
          className={styles.titleBlock}
        >
          {advtlines[0] && (
            <WordAnimator text={advtlines[0]} className={styles.firstLine} />
          )}
          {advtlines[1] && (
            <WordAnimator
              text={advtlines[1]}
              className={styles.secondLine}
              initDelay={0.5}
            />
          )}
          {advtlines[2] && (
            <WordAnimator
              text={advtlines[2]}
              className={styles.thirdLine}
              initDelay={1}
            />
          )}
        </motion.div>
      )}

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: {
                duration: 0.67,
                ease: 'easeOut',
                delay: initDelay + 5.2,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: {
                duration: 0.67,
                ease: 'easeOut',
                delay: initDelay + 5.6,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="" />
          </motion.div>
        )}
      </div>

      <BgVideo />
    </div>
  );
});
